import React from 'react';
import styles from './DropdownSubtitle.module.sass';

const DropdownSubtitle = ({
    iconBefore,
    children
}: Props) => {
    return <div className={styles['dropdown__subtitle']}>
        { iconBefore }
        { children }
    </div>
}

interface Props {
    iconBefore?: any
    children: string
}

export default React.memo(DropdownSubtitle);